/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published on`)
};

const es_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado el`)
};

const de_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht am`)
};

const nl_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gepubliceerd op`)
};

const fr_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publié le`)
};

const it_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicato il`)
};

const pt_br2_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado em`)
};

const pt_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado em`)
};

const ja_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開日`)
};

const zh_blog_published_on = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布于`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_published_on = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_published_on(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_published_on", locale)
	if (locale === "en") return en_blog_published_on(inputs)
	if (locale === "es") return es_blog_published_on(inputs)
	if (locale === "de") return de_blog_published_on(inputs)
	if (locale === "nl") return nl_blog_published_on(inputs)
	if (locale === "fr") return fr_blog_published_on(inputs)
	if (locale === "it") return it_blog_published_on(inputs)
	if (locale === "pt-BR") return pt_br2_blog_published_on(inputs)
	if (locale === "pt") return pt_blog_published_on(inputs)
	if (locale === "ja") return ja_blog_published_on(inputs)
	return zh_blog_published_on(inputs)
};